import { Gift } from '@app/models/gift';
import { createAction, props } from '@ngrx/store';

export const setAll = createAction('[Gifts] Set All Gifts', props<{ gifts: Gift[] }>());


// in game

export const unlock = createAction('[Gifts] Unlock Gifts', props<{ giftId: number }>());
